import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Form, Loader } from 'semantic-ui-react';
import { getWithAuth } from 'src/api';

export const ND_TEMPLATE_ID_KEY = 'cn.lp.ndtemplateid';

export const NDTemplate = ({ trigger = null }) => {
  const [projectId, accessPoints] = useSelector((state: any) => [
    state.mainFrame.projectId,
    state.mainFrame.accessPoints,
  ]);
  const storedId = localStorage.getItem(ND_TEMPLATE_ID_KEY);
  const [selected, setSelected] = useState(storedId);

  const apIds = accessPoints?.features.map((ap) => ap.properties.id) ?? [];
  const queryKey = [projectId, ...apIds];

  const { data: apSummary, isLoading } = useQuery({
    queryKey,
    queryFn: async () => {
      return await getWithAuth(`project/${projectId}/access_points/summary`);
    },
    initialData: null,
    retry: false,
    enabled: true,
  });

  useEffect(() => {
    if (!apIds.includes(selected) && selected !== 'none') {
      setSelected('none');
    }
  }, [apIds, storedId]);

  if (isLoading || apSummary === null || accessPoints == null) {
    return <Loader active inline />;
  }

  const summaryLookup = Object.fromEntries(apSummary.map((ap) => [ap.id, ap]));

  let nameOptions = [
    { key: 'none', text: '<no template - default settings>', value: 'none' },
  ];

  if (accessPoints.features) {
    const linkOptions = accessPoints.features
      .map((f, idx) => {
        const id = f.properties.id;
        const name = f.properties.name;
        const summaryInfo = summaryLookup[id];
        let textLabel = name;
        if (summaryInfo) {
          textLabel += ` [${summaryInfo.bands} / ${summaryInfo.products}]`;
        }
        return { key: `${idx}-${name}`, text: textLabel, value: id };
      })
      .sort((o1, o2) => o1.text.localeCompare(o2.text));

    nameOptions = nameOptions.concat(linkOptions);
  }

  return (
    <Form.Field>
      <label>
        <FormattedMessage
          id="ptpMode.existingND"
          defaultMessage="Configure From Existing Network Device"
        />
      </label>
      <Form.Select
        options={nameOptions}
        value={selected}
        onChange={(_, data) => {
          let newId = data.value.toString();
          if (newId === 'none') {
            newId = '';
            localStorage.removeItem(ND_TEMPLATE_ID_KEY);
          } else {
            localStorage.setItem(ND_TEMPLATE_ID_KEY, newId);
          }
          setSelected(newId);
          if (trigger) {
            trigger(newId);
          }
        }}
      />
    </Form.Field>
  );
};
